import { Grid } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from '../../../../redux/store';
import { AwaitButton } from '../../../../reusable-components/await-button';

RentalSubcategorySelect.propTypes = {
  subcategories: PropTypes.array,
  setSubcategories: PropTypes.func
};

export default function RentalSubcategorySelect({subcategories, setSubcategories}) {
  const {
    data: { categoryData },
  } = useSelector((state) => state.rentals);
  const [searchParams] = useSearchParams();
  const selectedCategory = searchParams.get('category');

  const handleItemClick = (item) => {
    setSubcategories(subcategories?.includes(item) ? subcategories?.filter((s) => s !== item) : [...subcategories, item]);
  };

  const filteredSubcategories = categoryData
    .filter((item) => item.categoryName === selectedCategory)
    .map((item) => item.subcategoryName);

  return (
    <>
      <div style={{ width: '100%' }}>
        <header>
          <Grid container spacing={2}>
             {selectedCategory && <Grid item key={'rentalsOnly'}>
                  <AwaitButton
                    sx={{
                      textAlign: 'center',
                      cursor: 'pointer',
                      color: subcategories?.includes('rentalsOnly') ? '#4CA5E7' : '#6D6E71',
                      border: subcategories?.includes('rentalsOnly') ? '1px solid #4CA5E7' : '1px solid #6D6E71',
                      borderRadius: '18px',
                      mb: 2,
                    }}
                    onClick={() => handleItemClick('rentalsOnly')}
                  >
                    Rentals Only
                  </AwaitButton>
                </Grid>}
            {selectedCategory &&
              filteredSubcategories.map((subcategoryName, index) => (
                <Grid item key={subcategoryName}>
                  <AwaitButton
                    sx={{
                      textAlign: 'center',
                      cursor: 'pointer',
                      color: subcategories?.includes(subcategoryName) ? '#4CA5E7' : '#6D6E71',
                      border: subcategories?.includes(subcategoryName) ? '1px solid #4CA5E7' : '1px solid #6D6E71',
                      borderRadius: '18px',
                      mb: 2,
                    }}
                    onClick={() => handleItemClick(subcategoryName)}
                  >
                    {subcategoryName}
                  </AwaitButton>
                </Grid>
              ))}
          </Grid>
        </header>
      </div>
    </>
  );
}
